import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteAirport } from "../../api/apiAirports";
import parseError from "../../utils/parseError";

const useForceDeleteAirport = () => {
    const queryClient = useQueryClient();

    const { mutate: forceDeleteAirportAction, isPending } = useMutation({
        mutationFn: forceDeleteAirport,
        onSuccess: (res) => {
            const message = res?.message || "Airport deleted permanently";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["airports"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to permanently delete airport");
        },
    });

    return { forceDeleteAirport: forceDeleteAirportAction, isForceDelete: isPending };
};

export default useForceDeleteAirport;
